import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { ContactSectionContent } from 'cpnl-common';
import { fetchContactSection } from './ContactSectionSlice';
import { ContactSectionContentSelector } from './ContactSectionContentSelector';

export function useContactSection(): AbstractContentState<ContactSectionContent> {
    return useCmsContent(fetchContactSection, ContactSectionContentSelector);
}
